import { render, staticRenderFns } from "./EventMenu.vue?vue&type=template&id=531050da"
import script from "./EventMenu.vue?vue&type=script&lang=js"
export * from "./EventMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports